module.exports = __webpack_public_path__ + "static/logo-black-287b37993f162826d1c427525e0b5fa0.png";